// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__DAV95","active":"styles_active__Lr2Pl"};